var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderMb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "border shadow-md",
    viewBox: "0 0 281.16 499.84",
    style: {
      width: "281.16px",
      height: "499.84px"
    },
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    x: 0,
    y: 0,
    width: 281.16,
    height: 499.84,
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 524.88,
    fill: "#F0A9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 489.888,
    fill: "#e6a0fd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 454.89599999999996,
    fill: "#dc97fb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 419.904,
    fill: "#d28ef9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 384.912,
    fill: "#c885f7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 349.91999999999996,
    fill: "#be7cf5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 314.928,
    fill: "#b473f3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 279.936,
    fill: "#aa6af1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 244.944,
    fill: "#a061ef"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 209.952,
    fill: "#9658ed"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 174.95999999999998,
    fill: "#8c4feb"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 139.968,
    fill: "#8246e9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 104.976,
    fill: "#783de7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 69.984,
    fill: "#6e34e5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.58,
    cy: 249.92,
    r: 34.992,
    fill: "#642be3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMb);
export default __webpack_public_path__ + "static/media/header-mb.367ef08409cf98d14d33c958155f0280.svg";
export { ForwardRef as ReactComponent };